import { findCup } from '@saucerjs/core';
import React, { useMemo } from 'react';
export var DropIndicator = React.memo(function (props) {
    var name = props.name;
    var displayName = useMemo(function () {
        var _a, _b;
        return (_b = (_a = findCup(name)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : name;
    }, [name]);
    return React.createElement("div", { className: "saucer-drop-indicator" }, displayName);
});
DropIndicator.displayName = 'DropIndicator';
